import React from "react";
import CreateReports from "../components/reports/create_reports";

const CreateReportMonaco = () => {
    return <CreateReports update={"lider"} sim={"Lider"} client={"leader"} />
}

export default CreateReportMonaco